import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

export const checkAuth = createAsyncThunk("auth/checkAuth", async () => {
  const token = localStorage.getItem('authToken'); // Recupera o token do localStorage

  if (!token) {
    return { token: null, isAuthenticated: false };
  }

  try {
    // Envia a requisição de verificação com o token do localStorage
    const response = await fetch(`${API_URL}/auth/verify`, {
      method: "POST", // Método POST
      headers: {
        "Content-Type": "application/json", // Tipo de conteúdo
        "Authorization": `Bearer ${token}`, // Usa o token para autenticação
      },
      credentials: "include", // Envia cookies automaticamente, permitindo o envio de cookies cross-origin
    });

    // Verifica se a resposta foi bem-sucedida
    if (!response.ok) {
      throw new Error("Erro ao verificar autenticação");
    }

    const data = await response.json();

    return { token: data.token, isAuthenticated: true, user: data.user };
  } catch (error) {
    return { token: null, isAuthenticated: false };
  }
});

// Thunk para salvar o User chamando a API
export const updateUser = createAsyncThunk(
  "auth/updateUser",
  async ({ userName, photoURL}, { rejectWithValue }) => {
    const token = localStorage.getItem('authToken');
    try {
      const response = await fetch(`${API_URL}/auth/update`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json" , 
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({ userName, photoURL }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Erro ao salvar User");

      return data; // Retorna os dados salvos para o Redux
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk para salvar o Dashboard chamando a API
export const updateUserPassword = createAsyncThunk(
  "users/updateUserPassword",
  async ({ currentPassword, newPassword }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/auth/updatePassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Erro ao salvar User");

      return data; // Retorna os dados salvos para o Redux
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
